import React from "react";
import { Trans, withTranslation, WithTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import CreditRatingRow from "src/components/CustomizePayment/PaymentFields/CreditRatingRow";
import { ApplicationStore } from "Types/state";
import "../../CustomizePayment/PaymentFields/PaymentFields.scss";
import ZipCodeRow from "../../CustomizePayment/ZipCode/ZipCodeRow";
import "./GlobalPaymentsControl.scss";
import CustomerRequestedTaxes from "src/components/CustomizePayment/CustomerRequestedTaxes";
import { isCalculateTaxesCustomerRequest } from "src/store/selectors/financeSettings";
import DrawerWrapper from "src/components/MyGarage/DrawerWrapper/Blocks/DrawerWrapper";
import styled from "styled-components";
import CloseIcon from "src/components/icons/Close";
import { toggleGarageDrawer } from "src/store/actions/garageDrawer";

const TRANSLATION_KEY = "MyGarage.GlobalPaymentsControl";

const CloseButton = styled("span")`
    position: absolute;
    top: 6px;
    right: 6px;
    cursor: pointer;
`;

const GlobalPaymentsControl = ({
    isViewingSoftCreditRatingForm,
    isTaxesCustomerRequested,
    toggleDrawer,
}: ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & WithTranslation) => {
    const history = useHistory();

    const handleClose = () => {
        toggleDrawer();
        history.push("/my-garage", history.location.state);
    };

    if (isViewingSoftCreditRatingForm) {
        return (
            <div className="GlobalPaymentsControl__container" data-e2e="globalPaymentsDrawer">
                <CloseButton onClick={handleClose}>
                    <CloseIcon />
                </CloseButton>
                <div className="GlobalPaymentsControl__drawer" style={{ paddingTop: "24px" }}>
                    <div className="GlobalPaymentsControl__slidersContainer">
                        <CreditRatingRow isDrawer={true} />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="GlobalPaymentsControl__container" data-e2e="globalPaymentsDrawer">
            <DrawerWrapper title={`${TRANSLATION_KEY}.title`} translateTitle={true}>
                <p className="GlobalPaymentsControl__header--copy">
                    <Trans i18nKey={`${TRANSLATION_KEY}.subtitle`} />
                </p>
                {isTaxesCustomerRequested ? (
                    <CustomerRequestedTaxes />
                ) : (
                    <div className="GlobalPaymentsControl__postalCodeContainer">
                        <ZipCodeRow />
                    </div>
                )}
                <div className="GlobalPaymentsControl__slidersContainer">
                    <CreditRatingRow isDrawer={true} />
                </div>
            </DrawerWrapper>
        </div>
    );
};

function mapStateToProps(state: ApplicationStore) {
    const { account, deal, onlineShopper } = state;
    return {
        account,
        uuid: deal.uuid,
        isViewingSoftCreditRatingForm: onlineShopper.isViewingSoftCreditRatingForm,
        isTaxesCustomerRequested: isCalculateTaxesCustomerRequest(state),
    };
}

const mapDispatchToProps = {
    toggleDrawer: toggleGarageDrawer,
};
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(GlobalPaymentsControl));
